import React from 'react';
import './App.css';
import PokedexComponent from './Components/PokedexComponent';

function App() {
  return (
    <PokedexComponent/>
  );
}

export default App;
